<template>
  <div class="MediaGrid">

    <div class="MediaGrid-item"
      v-for="(item, index) in media"
      :id="item.hash">

      <h2 class="MediaGrid-title t-heading-md"
        v-if="item.title"
        v-html="item.title">
      </h2>

      <div class="MediaGrid-description t-text-sm"
        v-if="item.description">

        <markdown :content="item.description" />

      </div>

      <div class="MediaGrid-section"
        v-if="item.sections"
        v-for="(section, index) in item.sections"
        :id="sectionId(section)">

        <h2 class="MediaGrid-sectionTitle t-caps-lg"
          v-if="section.title"
          v-html="section.title">
        </h2>

        <grid v-if="section.items">

          <grid-item
            v-for="(cell, index) in section.items"
            :key="index"
            :class="gridItemClasses(cell)"
            :style="gridItemStyles(cell)"
            :span="cell.span"
            @click.native="handleItemClick(cell.hash)">

            <article v-if="cell.type !== 'multi'">

              <component
                :is="`media-grid-item-${cell.type}`"
                :data="cell"
                :span="cell.span" />

            </article>

            <article v-if="cell.type === 'multi'">

              <grid>

                <grid-item
                  v-for="(item, index) in cell.items"
                  :key="index"
                  :class="item.class"
                  :style="item.style"
                  :span="item.span"
                  :order="item.order">

                  <component
                    v-if="item.type !== 'multi'"
                    :is="`media-grid-item-${item.type}`"
                    :data="item" />

                </grid-item>

              </grid>

            </article>

          </grid-item>

        </grid>

      </div>

    </div>

  </div>
</template>

<script>
import slugify from 'slugify'

export default {
  name: 'MediaGrid',

  props: {
    media: {
      type: Array,
      required: true
    }
  },

  mounted () {
    this.$nextTick(this.scrollToAnchor)
  },

  methods: {
    /**
     * Check for URL hash and scroll to anchor if it exists
     */
    scrollToAnchor () {
      if (!this.$route.hash) return
      const id = this.$route.hash.slice(1)
      const $el = document.getElementById(id)

      if (!$el) return

      setTimeout(() => {
        window.scrollTo(window.scrollX, $el.offsetTop)
      }, 200)
    },

    /**
     * Styles for the grid item
     * @param {Object} cell
     * @return {Object}
     */
    gridItemStyles (cell) {
      const styles = {}

      if (cell.hash) {
        styles.cursor = 'pointer'
      }

      return styles
    },

    /**
     * Classes for the grid item
     * @param {Object} cell
     * @return {Array}
     */
    gridItemClasses (cell) {
      const classes = []

      if (cell.class) classes.push(cell.class)

      return classes
    },

    /**
     * Handle click event on item
     * - Emits item's hash when present
     * @param {String} hash
     */
    handleItemClick (hash) {
      if (!hash) return
      this.$emit('select', hash)
    },

    /**
     * Return a slugged version of the section id
     * @param  {Object} section
     * @return {String}
     */
    sectionId (section) {
      if (!section.title) return
      return slugify(section.title, {
        lower: true
      })
    }
  }
}
</script>

<style>
@import 'properties';

.MediaGrid {

}

.MediaGrid-item {
  padding-top: 36px;
  padding-bottom: 24px;
}

.MediaGrid-item + .MediaGrid-item {
  border-top: 1px solid var(--c-grey-xxlt);
}

.theme-dk .MediaGrid-item + .MediaGrid-item {
  border-top-color: var(--c-black);
}

.MediaGrid-title {
  /* Leading compensation */
  margin-top: 20px; /* 24px */
  margin-bottom: 16px; /* 24px */
}

.MediaGrid-title + .MediaGrid-description {
  margin-top: -9px; /* 18px after leading compensation */
}

.MediaGrid-description {
  margin-bottom: 19px; /* 24px after leading compensation */
}

.MediaGrid-section {
}

/**
 * IE 11 clearfix
 */
.MediaGrid-section::after {
  display: table;
  content: '';
  clear: both;
}

.MediaGrid-section + .MediaGrid-section {
  /* outline: 2px solid hotpink; */
  margin-top: 60px; /* 36px between sections */
}

.MediaGrid-sectionTitle {
  margin-top: -6px; /* 0px after compensating for leading */
  margin-bottom: 16px; /* 24px after compensating for leading */
}

/* Add a little extra padding for full-span videos */
.GridItem--12\/12 .Tag--isLarge,
.GridItem--6\/6 .Tag--isLarge,
.GridItem--4\/4 .Tag--isLarge,
.GridItem--3\/3 .Tag--isLarge,
.GridItem--2\/2 .Tag--isLarge,
.GridItem--1\/1 .Tag--isLarge {

  @media (min-width: 400px) {
    margin: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// MediaGrid.vue?71137bd0